import { ComponentProps, PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'ui/src/components/Button/Button'
import { BaseDialog } from 'ui/src/components/Dialog/BaseDialog'
import { RoundCheckIcon } from 'ui/src/icons/RoundCheckIcon'
import { yStack } from 'ui/src/patterns/stack'
import { sprinkles } from 'ui/src/theme/sprinkles.css'
import { tokens } from 'ui/src/theme/tokens.css'

type Props = PropsWithChildren<{
  open: boolean
  onOpenChange: (open: boolean) => void
  insurerName: string
}>

function ExternalInsuranceCancellationNoticeRoot({ open, onOpenChange, insurerName, children }: Props) {
  const { t } = useTranslation('cart')

  return (
    <BaseDialog.Root open={open} onOpenChange={onOpenChange}>
      <BaseDialog.Overlay frosted>
        <BaseDialog.Content size="sm" className={sprinkles({ padding: 'md', paddingTop: 'xxl' })}>
          <div className={yStack({ gap: 'xl' })}>
            <div className={yStack({ alignItems: 'center', gap: 'md' })}>
              <RoundCheckIcon size="2.5rem" color={tokens.colors.signal.green.element} />
              <div>
                <BaseDialog.Title align="center" variant="standard.18" balance>
                  {t('ADDED_TO_CART_LABEL', { ns: 'purchase-form' })}
                </BaseDialog.Title>
                <BaseDialog.Description
                  align="center"
                  variant="standard.18"
                  color={tokens.colors.text.opaque.secondary}
                  balance
                >
                  {t('RECOMMENDED_OFFER_ADDED_DIALOG_DESCRIPTION', { insurer: insurerName })}
                </BaseDialog.Description>
              </div>
            </div>

            {children}
          </div>
        </BaseDialog.Content>
      </BaseDialog.Overlay>
    </BaseDialog.Root>
  )
}

function ExternalInsuranceCancellationConfirmButton({ children, ...props }: ComponentProps<typeof Button>) {
  const { t } = useTranslation('cart')

  return (
    <Button size="large" fullWidth={true} {...props}>
      {children ?? t('RECOMMENDED_OFFER_ADDED_DIALOG_CONFIRM_BUTTON')}
    </Button>
  )
}

export const ExternalInsuranceCancellationNotice = {
  Root: ExternalInsuranceCancellationNoticeRoot,
  ConfirmButton: ExternalInsuranceCancellationConfirmButton,
}
